<div class="container-box review-order-page" *ngIf="cart !== null">

  <!-- Success Message Block -->
  
  <!-- Biil to Section Ends -->
  <!-- <div role="product details"> -->
     <!-- <div role="grid">-->
    <!-- Table Column Start -->

    <!-- <h2 class="title-columns" role="row"> <span role="columnheader"> Product</span> <span role="columnheader" class="pull-right"> Amount </span> </h2> -->

    <!-- Table Column End -->
    <!-- <div class="product-details" *ngFor="let obj of cart.lineItems">
      <hr class="details-hr" /> -->
      <!-- Workforce Manager Block Starts -->
      <!-- <div class="row" role="row"> -->
        <!-- Block Wise Iteration Starts -->
        <!-- <div class="col-sm-12 col-md-12">
          <p class="row-headings product-name"> {{obj.sku && obj.sku.displayName}} - {{obj.sku && obj.sku.skuType}} </p>
          <p> <b>Monthly charges </b> </p>
        </div>
      </div>
      <div class="row line-items" role="row" *ngIf="obj.maxQty > 1"> -->
        <!-- Line Items Iteration Start -->
        <!-- <div class="col-sm-6 col-md-6"> -->
          <!-- <p>{{obj.sku && obj.sku.skuType}} ({{obj.sku && obj.sku.priceInfo.monthlyRecurringFee.amount |currency:'USD':true:'1.2-3'}}/user)-->
          <!-- <p role="coloumn"><span [innerHTML]="(obj.quantity > 1)? 'Number of licenses':'Number of license'"></span> {{obj.quantity}} &#64; {{obj.sku
            && obj.sku.priceInfo.monthlyRecurringFee.amount |currency:'USD':true:'1.2-3'}}/user
          </p>
        </div>
        <div class="col-sm-6 col-md-6 text-right" role="coloumn">
          <p class="price-value align-right"> {{obj.priceInfo && obj.priceInfo.monthlyRecurringFee.amount|currency:'USD':true:'1.2-3'}}
          </p>
          <small class="permonth align-right"> per month </small>
        </div>
      </div>
	  <div class="row line-items" role="row" *ngIf="obj.maxQty == 1" > -->
        <!-- Line Items Iteration Start -->
        <!-- <div class="col-sm-6 col-md-6"> -->
          <!-- <p>{{obj.sku && obj.sku.skuType}} ({{obj.sku && obj.sku.priceInfo.monthlyRecurringFee.amount |currency:'USD':true:'1.2-3'}}/user)-->
          <!-- <p role="coloumn">License Price (Unlimited Users)
          </p>
        </div>
        <div class="col-sm-6 col-md-6 text-right" role="coloumn">
          <p class="price-value align-right"> {{obj.priceInfo && obj.priceInfo.monthlyRecurringFee.amount|currency:'USD':true:'1.2-3'}}
          </p>
          <small class="permonth align-right"> per month </small>
        </div>
      </div>
      <div *ngIf="obj?.priceInfo?.monthlyRecurringFee?.discountAmount > 0" role="row" class="row line-items top-margin"> -->
        <!-- Line Items Iteration Start -->
        <!-- <div class="col-sm-6 col-md-6" role="coloumn">
          <p class="est-img"> <i class="icon-retail-offers"></i> Estimated discount </p>
        </div>
        <div class="col-sm-6 col-md-6 text-right" role="coloumn">
          <p class="price-value align-right"> - {{obj.priceInfo && obj?.priceInfo?.monthlyRecurringFee?.discountAmount |currency:'USD':true:'1.2-3'}}
          </p>
          <small class="permonth align-right"> per month </small>
        </div>
      </div> -->
      <!-- Line Items Iteration Ends -->
      <!-- <div class="line-items">
              <p><span class="label-text">Number of licenses:</span> <span class="label-value">{{obj.quantity}}</span></p>
            </div>-->
      <!-- <div class="line-items" *ngFor="let prod of obj.productConfigurations" role="row"> -->
        <!-- Line Items Iteration Start -->
        <!-- <div *ngIf="prod.show">
          <p *ngIf="!prod.isDropDown"><span class="label-text" role="coloumn">{{prod.label}}:</span> <span class="label-value">{{prod.value}}</span></p>
          <p *ngIf="prod.isDropDown"><span class="label-text" role="coloumn">{{prod.label}}:</span> <span class="label-value">{{prod.value.value}}</span>            </p>
        </div>
      </div> -->
      <!-- Line Items Iteration Ends -->
      <!-- One-time Charges Start -->
      <!-- <div role="row" class="" *ngIf="obj.priceInfo && obj.priceInfo.oneTimeFee.length > 0">
        <div class="row">
          <div class="col-sm-8 col-md-8">
            <p role="coloumn"> <b>One-time charges </b> </p>
          </div>
        </div>
        <ng-template let-charge ngFor [ngForOf]="obj.priceInfo.oneTimeFee">
          <div class="row otc-line-items" role="coloumn">
            <div class="col-sm-6 col-md-6">
              <p class="otc-sub-headings">{{charge.oneTimeFeeName}} </p>
            </div>
            <div class="col-sm-6 col-md-3 text-right" role="coloumn">
              <p class="price-value" *ngIf="(!charge.customPrice) || (charge.customPrice === 0)">{{charge.unitPrice|currency:'USD':true:'1.2-3'}} </p>
              <p class="price-value" *ngIf="(charge.customPrice) && (charge.customPrice > 0)">{{charge.customPrice|currency:'USD':true:'1.2-3'}} </p>
              <small class="permonth"> one-time payment </small>
            </div>
          </div>
          <div role="row" class="row otc-line-items" *ngIf="(obj.priceInfo.oneTimeFee.length === 1) && (charge?.discount > 0)">
            <div class="col-sm-6 col-md-6" role="coloumn">
              <p class="otc-sub-headings est-img"> <i class="icon-retail-offers"></i> Estimated discount</p>
            </div>
            <div class="col-sm-6 col-md-3 text-right" role="coloumn">
              <p class="price-value"> - {{charge.discount|currency:'USD':true:'1.2-3'}}</p>
              <small class="permonth">  one-time payment </small>
            </div>
          </div>
        </ng-template>
        <div *ngIf="(obj.priceInfo.oneTimeFee.length > 1) && (obj.priceInfo?.totalOneTimeDiscount > 0)"
           class="row  otc-line-items est-discount" role="row">
          <div class="col-sm-6 col-md-6" role="coloumn">
            <p class="otc-sub-headings est-img"> <i class="icon-retail-offers"></i> Estimated discount</p>
          </div>
          <div class="col-sm-6 col-md-3 text-right" role="coloumn">
            <p class="price-value"> - {{obj.priceInfo?.totalOneTimeDiscount|currency:'USD':true:'1.2-3'}}</p>
            <small> one-time payment </small>
          </div>
          <div class="clearfix"></div>
        </div>
      </div> -->
      <!-- One Charges End -->
      <!--    </div> -->
      <!-- Block Wise Iteration Ends -->
    <!-- </div> -->
    <!-- Workforce Manager Blocks End -->

    <!-- <hr class="top" />
    <div class="product-details" role="row"> -->
      <!-- Total Charges Block Start -->
      <!-- <h2>Total charges*</h2>
      <div class="row total-line-items">
        <div class="col-sm-7 col-md-6" role="coloumn">
          <p> Total monthly charges </p>
        </div>
        <div class="col-sm-5 col-md-6 text-right" role="coloumn">
          <p class="total-price align-right">{{cart.priceInfo && cart.priceInfo.monthlyRecurringFee.amount |currency:'USD':true:'1.2-3'}}</p>
        </div>
      </div>
      <div class="row total-line-items">
        <div class="col-sm-7 col-md-6" role="coloumn">
          <p> Total one-time charges</p>
        </div>
        <div class="col-sm-5 col-md-3 text-right" role="coloumn">
          <p class="total-price align-right"> {{cart.priceInfo && cart.priceInfo.oneTimeFee.amount |currency:'USD':true:'1.2-3'}}</p>
        </div>
      </div>
    </div> -->
    <!-- Total Charges Block Ends -->
    <!-- <hr/>
  </div> -->
  <!-- Terms and Condtions Section -->
  <!-- <div class="tnc">
    <p class="last-text">Legal agreement</p>
    <p *ngIf="!routeStatus"> {{tnctitle}} is subject to its <a [attr.aria-label]=" tnctitle + 'is subject to its Terms & Conditions (Opens in new window)' "
        href="assets/pdf/Terms-of-Use-for-AT&T-Device-Enrollment2025.pdf" target="_blank">Terms & Conditions.</a></p>
    <p> <small>* Totals are based on estimated charges. Taxes and fees will be calculated for applicable charges. Charges will appear on your billing statement. You may not see any discounts or bill credits subtracted from your charges until you select your billing account on the <b>Checkout</b> page.</small>      </p>
  </div> -->
  <!-- Terms and Conditions Section Ends -->
  <!-- <hr class="bot-30" />
  <div class="line-footer checkout-area text-right">

    <button *ngIf="!routeStatus" [disabled]='csrPermissionSubmitButton || !isCheckoutValid' class="btn btn-success btn-checkout pull-right"
      type="button" (click)="placeorder()" aria-label="Submit."> Submit order </button>
    <a *ngIf="!routeStatus" class="btn btn-link btn-shopping" href="javascript:void(0);" (click)="prevStep()"> Back </a>
  </div> -->
  <!-- Sumbit Order Ends -->
</div>